import { render, staticRenderFns } from "./detailHelp.vue?vue&type=template&id=3cf8960e&"
import script from "./detailHelp.vue?vue&type=script&lang=js&"
export * from "./detailHelp.vue?vue&type=script&lang=js&"
import style0 from "./detailHelp.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports